import React from 'react';
import { ThemeProvider } from 'styled-components';
import * as Colors from './colors';
import * as Fonts from './fonts';

export const theme = {
  color: {
    primary: Colors.Navy,
    secondary: Colors.Grey,
    danger: Colors.Red,
    warning: '#545454', // Do we use coral here?
    white: Colors.White,
    purple: Colors.Purple,
  },
  font: {
    family: {
      primary: Fonts.BodyFont, // Deprecate
      body: Fonts.BodyFont,
      heading: Fonts.HeadlineFont,
    },
    size: {
      small: '14px',
      default: '16px',
      medium: '18px',
      large: '21px',
      xlarge: '28px',
      xxlarge: '37px',
      xxxlarge: '50px',
    },
    weight: {
      light: 200,
      default: 400,
      medium: 500,
      bold: 700,
      black: 900,
    },
  },
  breakpoints: {
    sm: '374px',
    md: '650px',
    lg: '700px',
    belowSm: 'only screen and (max-width: 375px)',
    aboveSm: 'only screen and (min-width: 375px)',
    belowMd: 'only screen and (max-width: 650px)',
    aboveMd: 'only screen and (min-width: 650px)',
    belowLg: 'only screen and (max-width: 700px)',
    aboveLg: 'only screen and (min-width: 700px)',
    aboveXl: 'only screen and (min-width: 1536px)',
  },
} as const;

function NewBrandThemeProvider(props: { children: React.ReactNode }) {
  return <ThemeProvider theme={theme} {...props} />;
}

export default NewBrandThemeProvider;
